import React, { useEffect, useRef } from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import RenderDataModal from '../RenderViewModal/RenderViewModal'
import { quickView } from '../../../../services/endpoints/quickView'
import useAsyncService from '../../../../hooks/useAsyncService'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'
import './HtmlDialog.css'

export interface HtmlDialogProps {
  onClose: () => void
  uploadFileVersionId: number
  fileName: string
}
const HtmlDialog: React.FC<HtmlDialogProps> = ({ onClose, uploadFileVersionId, fileName }) => {
  const {serviceValue, serviceLoading, serviceError} = useAsyncService({
    serviceCall: quickView,
    initialArgs: uploadFileVersionId,
    validateServiceResults(res) {
        return typeof res === 'string'
    }
  })
    
  const getBody = () => {    
    if(serviceLoading) {
      return (
           <LoadIndicator />
      )
    } else if(serviceError) {
      return(
          <ICSErrorCard
            code={'error'}
            message={serviceError}
            fields={[]}
          />
      )
    } else if(!serviceValue) {
      return <>Empty</>
    } else {
      return (
        //@ts-ignore
        <RenderHtml body={serviceValue} />
      )
    }
  }
  return (
    <RenderDataModal onClose={onClose} title={`HTML File for ${fileName}`}>
      <Container className="notes-container">
        <Row className="notes-row">
          <Col>
            {getBody()}
          </Col>
        </Row>
      </Container>
    </RenderDataModal>
  )
}

const RenderHtml: React.FC<{body: string}> = ({body}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      const doc = iframeRef.current?.contentWindow?.document;
      if(doc) {
        doc.open();
        doc.write(body);
        doc.close();
      }
    }
  }, [body]);

  return <iframe className="custom-html-frame" ref={iframeRef} title="rendered-html" />;
}

export default HtmlDialog
